export default __webpack_public_path__ + "static/media/staff-user-white.c3b587dd.svg";